import { useEffect, useState } from 'react';
import { PhoneInput } from 'react-international-phone';
import { isPossiblePhoneNumber } from 'libphonenumber-js';
import { fetchGeo } from '../../lib/api';
import 'react-international-phone/style.css';

interface Props {
  value: string;
  onChange: (value: string, isValid: boolean) => void;
}

type ValidationState = 'idle' | 'valid' | 'invalid';

export function WhatsAppInput({ value, onChange }: Props) {
  const [defaultCountry, setDefaultCountry] = useState('ni');
  const [phoneValue, setPhoneValue] = useState(value);
  const [validation, setValidation] = useState<ValidationState>('idle');
  const [countryLoaded, setCountryLoaded] = useState(false);

  useEffect(() => {
    fetchGeo()
      .then(data => {
        if (data.country) {
          setDefaultCountry(data.country.toLowerCase());
          localStorage.setItem('hit_country_detected', data.country);
        }
      })
      .finally(() => setCountryLoaded(true));
  }, []);

  useEffect(() => {
    if (!phoneValue || phoneValue.length < 4) {
      setValidation('idle');
      onChange(phoneValue, false);
      return;
    }

    const valid = isPossiblePhoneNumber(phoneValue);
    setValidation(valid ? 'valid' : 'invalid');
    onChange(phoneValue, valid);
  }, [phoneValue]);

  if (!countryLoaded) {
    return (
      <div className="h-12 bg-hit-gray-light/30 rounded-md animate-pulse" aria-label="Cargando..." />
    );
  }

  return (
    <div className="flex flex-col gap-2">
      <PhoneInput
        defaultCountry={defaultCountry}
        value={phoneValue}
        onChange={phone => setPhoneValue(phone)}
        allowMaskOverflow
        inputProps={{
          autoComplete: 'tel',
          inputMode: 'tel',
          'aria-label': 'Número de WhatsApp',
          'aria-required': 'true',
          className: 'hit-input flex-1',
        }}
        style={
          {
            '--react-international-phone-border-color': '#9CA3AF',
            '--react-international-phone-border-radius': '6px',
            '--react-international-phone-font-size': '16px',
            '--react-international-phone-height': '48px',
          } as React.CSSProperties
        }
      />
      <ValidationFeedback state={validation} />
    </div>
  );
}

function ValidationFeedback({ state }: { state: ValidationState }) {
  if (state === 'valid') {
    return <p className="text-emerald-600 text-sm font-medium">✓ Formato válido</p>;
  }
  if (state === 'invalid') {
    return (
      <p className="text-red-600 text-sm font-medium">
        ✗ Verifica que el número esté completo
      </p>
    );
  }
  return null;
}
